var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cx_card_item",class:{right: _vm.right}},[_c('span',{class:{cx_link_item : _vm.link || _vm.openlink || _vm.func},on:{"click":_vm.onClick}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }